window.PdpSiblingSwap = window.PdpSiblingSwap || {
  selector: 'a[data-pdp-sibling-swap]',
  controller: null,

  init() {
    document.addEventListener('click', (event) => {
      const link = event.target.closest(this.selector);
      if (!link) return;
      if (link.classList.contains('sibling__link--current')) return;

      event.preventDefault();
      this.swap(link);
    });
  },

  swap(link) {
    const main = document.querySelector('main');
    if (!main) return;

    this.controller?.abort();
    const controller = new AbortController();
    this.controller = controller;

    main.style.opacity = '0.6';
    main.style.pointerEvents = 'none';

    fetch(link.href, { signal: controller.signal })
      .then((response) => response.text())
      .then((responseText) => {
        const doc = new DOMParser().parseFromString(responseText, 'text/html');
        const newMain = doc.querySelector('main');
        if (!newMain) throw new Error('PDP sibling swap: no <main> found in response');

        const onSwapped = () => {
          document.title = doc.title;
          window.history.pushState({}, '', link.href);
          window.scrollTo({ top: 0, behavior: 'instant' });
          this.reinitRebuy();
          this.reinitYotpo();
          this.hideYotpoAiDataBlock();
        };

        const swapWithUtility = window.HTMLUpdateUtility && typeof window.HTMLUpdateUtility.viewTransition === 'function';
        if (swapWithUtility) {
          window.HTMLUpdateUtility.viewTransition(main, newMain, [], [onSwapped]);
        } else {
          main.replaceWith(newMain);
          onSwapped();
        }
      })
      .catch((error) => {
        if (error.name === 'AbortError') return;
        console.error(error);
        window.location.href = link.href;
      });
  },

  // The new <main> brings fresh, empty Rebuy widget nodes - one init picks up all of them.
  reinitRebuy() {
    window.Rebuy?.init?.();
  },

  reinitYotpo() {
    if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
      window.yotpoWidgetsContainer.initWidgets();
      return;
    }

    if (window.yotpo && typeof window.yotpo.refreshWidgets === 'function') {
      window.yotpo.refreshWidgets();
    }
  },

  hideYotpoAiDataBlock() {
    document.getElementById('yotpo-reviews-section-data')?.style.setProperty('display', 'none');
  },
};

document.addEventListener('DOMContentLoaded', () => {
  PdpSiblingSwap.init();
});
